//@flow
import React from "react"
import { Field, reduxForm } from "redux-form"
import {
  InputField,
  Label,
  FormGroup,
  Error,
  FormRow,
  FormCol,
  Note
} from "../UI/Form"
import { PrimaryButton, SecondaryButton, DangerButton } from "../UI/Buttons"
import validate from "./validate"
import type { AttractLoopFormProps } from "./types"

const AttractLoopForm = ({
  handleSubmit,
  handleCancel,
  handleChange,
  handleDelete,
  error,
  isNew,
  pristine,
  id
}: AttractLoopFormProps) =>
  <form onSubmit={handleSubmit}>
    <Note>Note: All fields REQUIRED</Note>

    <FormRow>
      <FormCol grow={2}>
        <FormGroup>
          <Label htmlFor="title">Title</Label>
          <Field
            name="title"
            component={InputField}
            type="text"
            onChange={handleChange}
          />
        </FormGroup>
      </FormCol>
      <FormCol grow={1}>
        <Note>This is the title for the attract loop.</Note>
      </FormCol>
    </FormRow>

    {error &&
      <Error>
        {error}
      </Error>}

    <FormRow>
      <FormCol grow={2}>
        <FormRow>
          <FormCol grow={1} />
          <FormCol grow={1}>
            <SecondaryButton block={true} onClick={handleCancel}>
              Cancel
            </SecondaryButton>
          </FormCol>
          <FormCol grow={1}>
            <PrimaryButton block={true} disabled={!isNew && pristine}>
              {isNew ? "Create" : "Update"} Attract Loop
            </PrimaryButton>
          </FormCol>
        </FormRow>
      </FormCol>
      <FormCol grow={1}>
        <Note>
          When you create a new user they receive a confirmation email.
        </Note>
      </FormCol>
    </FormRow>
    {isNew
      ? ""
      : <div>
          <FormRow>
            <FormCol grow={2}>
              <FormRow>
                <FormCol grow={1} />
                <FormCol grow={1} />
                <FormCol grow={1}>
                  <DangerButton block={true} onClick={handleDelete}>
                    Delete Attract Loop
                  </DangerButton>
                </FormCol>
              </FormRow>
            </FormCol>
            <FormCol grow={1}>
              <Note>This cannot be undone.</Note>
            </FormCol>
          </FormRow>
        </div>}
  </form>

export default reduxForm({
  form: "attractLoop",
  enableReinitialize: true,
  validate
})(AttractLoopForm)



// WEBPACK FOOTER //
// ./src/AttractLoops/AttractLoopForm.js